const config = {
    'dispatchCenter': {
        'bigData-btn-search': '订单管理-城配,调度中心,,调度中心-查询',
        'bigData-btn-delivery': '订单管理-城配,调度中心, ,修改配送方式',
        'bigData-btn-cancel-allocation': '订单管理-城配,调度中心, ,取消分拨',
        'bigData-btn-allocation': '订单管理-城配,调度中心, ,分拨',
        'bigData-btn-intelligent-platoon': '订单管理-城配,调度中心, ,智能排车',
        'bigData-btn-create-platoon': '订单管理-城配,调度中心, ,排车',
        'bigData-btn-create-departure': '订单管理-城配,调度中心, ,新建发车单',
        'bigData-btn-transfer': '订单管理-城配,调度中心, ,转移',
        'bigData-btn-confirm': '订单管理-城配,调度中心, ,确认'
    },
    'dispatchOrder': {
        'bigData-btn-search': '订单管理-城配,发车单管理,,发车单管理-查询',
        'bigData-btn-print': '订单管理-城配,发车单管理,,打印',
        'bigData-btn-print-log': '订单管理-城配,发车单管理,,打印日志'
    },
    // 发车单管理(新)
    performanceDispatchOrder: {
        'bigData-btn-print': '订单管理-城配,发车单管理(新),,打印',
        'bigData-btn-batch-print': '订单管理-城配,发车单管理(新),,批量打印',
        'bigData-btn-print-log': '订单管理-城配,发车单管理(新),,打印日志',
        'bigData-btn-jump-old-print': '订单管理-城配,发车单管理(新),,跳转到老版打印',
        'bigData-btn-print-preview': '订单管理-城配,发车单管理(新),,打印预览',
        'bigData-btn-new-label': '订单管理-城配,发车单管理(新),,新建标签',
        'bigData-btn-label-management': '订单管理-城配,发车单管理(新),,标签管理',
        'bigData-btn-export': '订单管理-城配,发车单管理(新),,导出',
        'bigData-btn-export-detail': '订单管理-城配,发车单管理(新),,导出发车单商品明细',
        'bigData-btn-batch-departure': '订单管理-城配,发车单管理(新),,批量发车',
        'bigData-btn-departure-reason': '订单管理-城配,发车单管理(新),,整车异常发车原因',
        'bigData-btn-revenue-cost': '订单管理-城配,发车单管理(新),,发车收入成本重算',
        'bigData-btn-recalculation-revenue': '订单管理-城配,发车单管理(新),,发车单收入重算',
        'bigData-btn-recalculation-cost': '订单管理-城配,发车单管理(新),,发车单成本重算',
        'bigData-btn-departure-rearrangement': '订单管理-城配,发车单管理(新),,发车重排',
        'bigData-btn-arrival-registration': '订单管理-城配,发车单管理(新),,到车登记',
        'bigData-btn-cancel-arrival': '订单管理-城配,发车单管理(新),,取消到车',
        'bigData-btn-detailed-loading': '订单管理-城配,发车单管理(新),,明细装车',
        'bigData-btn-whole-loading': '订单管理-城配,发车单管理(新),,整单装车',
        'bigData-btn-start': '订单管理-城配,发车单管理(新),,发车',
        'bigData-btn-confirmation-arrival': '订单管理-城配,发车单管理(新),,运抵确认',
        'bigData-btn-cost-verification': '订单管理-城配,发车单管理(新),,成本校验',
        'bigData-btn-cost-approval': '订单管理-城配,发车单管理(新),,成本审批',
        'bigData-btn-contract-route': '订单管理-城配,发车单管理(新),,零担下发',
        'bigData-btn-distribute': '订单管理-城配,发车单管理(新),,取消零担下发',
        'bigData-btn-cancel-distribute': '订单管理-城配,发车单管理(新),,合同外线路',
        'bigData-btn-transportation-agreement': '订单管理-城配,发车单管理(新),,运输协议',
        'bigData-btn-device': '订单管理-城配,发车单管理(新),,发车单设备',
        'bigData-btn-park-appointment': '订单管理-城配,发车单管理(新),,园区预约',
        'bigData-btn-transit-registration': '订单管理-城配,发车单管理(新),,在途登记',
        'bigData-btn-location-information': '订单管理-城配,发车单管理(新),,位置信息查看',
        'bigData-btn-loading-sequence': '订单管理-城配,发车单管理(新),,装车顺序',
        'bigData-btn-viewing-trajectories': '订单管理-城配,发车单管理(新),,查看轨迹',
        'bigData-btn-abnormal-reason': '订单管理-城配,发车单管理(新),,整车异常发车原因',
        'bigData-btn-edit-costs': '订单管理-城配,发车单管理(新),,编辑运输成本',
        'bigData-btn-cancel-loading': '订单管理-城配,发车单管理(新),,取消装货',
        'bigData-btn-import': '订单管理-城配,发车单管理(新),,导入',
        'bigData-btn-granting-privileges': '订单管理-城配,发车单管理(新),,特权下发直通宝',
        'bigData-btn-cost-anomaly': '订单管理-城配,发车单管理(新),,成本异常查看',
        'bigData-btn-cost-verification-by-car': '订单管理-城配,发车单管理(新),,成本校验-按车计费',
        'bigData-btn-billing-trial': '订单管理-城配,发车单管理(新),,成本试算',
        'bigData-btn-dispatch-edit': '订单管理-城配,发车单管理(新),,发车单编辑',
        'bigData-btn-task-device': '订单管理-城配,发车单管理(新),,任务设备',
        'bigData-btn-in-transit-edit': '订单管理-城配,发车单管理(新),,在途编辑',
        'bigData-btn-vehicle-record': '订单管理-城配,发车单管理(新),,车辆改派记录',
        'bigData-btn-rank-recalculate': '订单管理-城配,发车单管理(新),,日趟数重算',
        'bigData-btn-batch-billing-trial': '订单管理-城配,发车单管理(新),,批量成本试算',
        'bigData-btn-dispatch-status': '订单管理-城配,发车单管理(新),,发车单状态列字段按钮'
    },
    // 发车单管理(新)明细
    PerformanceDispatchInfo: {
        'bigData-btn-print': '订单管理-城配,发车单管理(新)明细,,打印',
        'bigData-btn-dispatch-log': '订单管理-城配,发车单管理(新)明细,,发车单日志'
    },
    'transportPage': {
        'bigData-btn-search': '订单管理-城配,运输单管理,,运输单管理-查询'
    },
    'trafficTrajectory': {
        'bigData-btn-search': '订单管理-城配,行车轨迹,,行车轨迹-查询'
    },
    'receiptSign': {
        'bigData-btn-search': '订单管理-城配,回单签收,,回单签收-查询'
    },
    'transferCreate': {
        'bigData-btn-search': '订单管理-城配,移交创建,,移交创建-查询'
    },
    'transferConfirm': {
        'bigData-btn-search': '订单管理-城配,移交确认,,移交确认-查询'
    },
    'evaluateQuery': {
        'bigData-btn-search': '订单管理-城配,客评查询,,客评查询-查询'
    },
    dispatchManageBasePlatoon: {
        'bigData-btn-cancel-allocation': '订单管理-城配,基地排车,,取消分拨',
        'bigData-btn-distribute': '订单管理-城配,基地排车,,下发',
        'bigData-btn-withdraw': '订单管理-城配,基地排车,,撤回',
        'bigData-btn-batch-allocation': '订单管理-城配,基地排车,,批量分拨',
        'bigData-btn-allocation': '订单管理-城配,基地排车,,分拨',
        'bigData-btn-loading-sequence': '订单管理-城配,基地排车,,装车顺序',
        'bigData-btn-create-platoon': '订单管理-城配,基地排车,,排车',
        'bigData-btn-create-departure': '订单管理-城配,基地排车,,新建发车单',
        'bigData-btn-confirm': '订单管理-城配,基地排车,,确认'
    },
    // 签收中心
    receiptCenter: {
        'bigData-btn-new-label': '订单管理-城配,回单签收,,新建标签',
        'bigData-btn-label-management': '订单管理-城配,回单签收,,标签管理',
        'bigData-btn-export': '订单管理-城配,回单签收,,导出',
        'bigData-btn-export-detail': '订单管理-城配,回单签收,,导出签收商品明细',
        'bigData-btn-batch-receipt': '订单管理-城配,回单签收,,批量签收',
        'bigData-btn-batch-upload': '订单管理-城配,回单签收,,批量上传回单',
        'bigData-btn-abnormal-approval': '订单管理-城配,回单签收,,异常审批',
        'bigData-btn-batch-overdue': '订单管理-城配,回单签收,,批量逾期',
        'bigData-btn-sign': '订单管理-城配,回单签收,,签收',
        'bigData-btn-rejection': '订单管理-城配,回单签收,,拒收',
        'bigData-btn-change': '订单管理-城配,回单签收,,签收改拒收',
        'bigData-btn-late-registration': '订单管理-城配,回单签收,,逾期登记',
        'bigData-btn-overdue-query': '订单管理-城配,回单签收,,逾期明细查询',
        'bigData-btn-repush': '订单管理-城配,回单签收,,重推',
        'bigData-btn-reject': '订单管理-城配,回单签收,,批量拒收',
        'bigData-btn-recheck': '订单管理-城配,回单签收,,反查',
        'bigData-btn-modification': '订单管理-城配,回单签收,,增值费修改',
        'bigData-btn-upload-file': '订单管理-城配,回单签收,,附件上传',
        'bigData-btn-pre-receipt-log': '订单管理-城配,回单签收,,预签收日志',
        'bigData-btn-three-one-rePush': '订单管理-城配,回单签收,,三一重推',
        'bigData-btn-batch-view-file': '订单管理-城配,回单签收,,批量查看附件',
        'bigData-btn-batch-delete-file': '订单管理-城配,回单签收,,批量删除附件'
    },
    // 运输单管理(新)
    waybillManage: {
        'bigData-btn-new-label': '订单管理-城配,运输单管理(新),,新建标签',
        'bigData-btn-label-management': '订单管理-城配,运输单管理(新),,标签管理',
        'bigData-btn-export': '订单管理-城配,运输单管理(新),,导出',
        'bigData-btn-view-track': '订单管理-城配,运输单管理(新),,查看轨迹',
        'bigData-btn-print-log': '订单管理-城配,运输单管理(新),,打印日志',
        'bigData-btn-pull-loading-data': '订单管理-城配,运输单管理(新),,拉取OTP装货数据',
        'bigData-btn-bind-ld-waybillNo': '订单管理-城配,运输单管理(新),,绑定零担运单号',
        'bigData-btn-batch-print': '订单管理-城配,运输单管理(新),,批量打印',
        'bigData-btn-task-status': '订单管理-城配,运输单管理(新),,运单状态列字段按钮'
    },
    // 运单管理(新)明细
    waybillDetail: {
        'bigData-btn-task-log': '订单管理-城配,运输单管理(新),,发车单日志'
    },
    // 司机运费支付
    DriverExpensePayment: {
        'bigData-btn-driver-expense-split-tab': '财务结算,司机运费管理,司机运费支付,司机费用分账',
        'bigData-btn-driver-expense-split-export': '财务结算,司机运费管理,司机运费支付,司机费用分账-导出',
        'bigData-btn-driver-expense-split-divide': '财务结算,司机运费管理,司机运费支付,司机费用分账-分账',
        'bigData-btn-driver-expense-split-adjust': '财务结算,司机运费管理,司机运费支付,司机费用分账-调整',
        'bigData-btn-driver-expense-split-payment': '财务结算,司机运费管理,司机运费支付,司机费用分账-发起支付',
        'bigData-btn-payment-record-tab': '财务结算,司机运费管理,司机运费支付,支付记录',
        'bigData-btn-payment-record-export': '财务结算,司机运费管理,司机运费支付,支付记录-导出',
        'bigData-btn-payment-record-divideNoCount': '财务结算,司机运费管理,司机运费支付,支付记录-包含的分帐单',
        'bigData-btn-payment-record-updateStatus': '财务结算,司机运费管理,司机运费支付,支付记录-更新状态',
        'bigData-btn-driver-expense-unfreeze-tab': '财务结算,司机运费管理,司机运费支付,运费解冻释放',
        'bigData-btn-driver-expense-unfreeze-export': '财务结算,司机运费管理,司机运费支付,运费解冻释放-导出',
        'bigData-btn-account-balance-tab': '财务结算,司机运费管理,司机运费支付,美的付账户余额',
        'bigData-btn-account-balance-register': '财务结算,司机运费管理,司机运费支付,美的付账户余额-去开通',
        'bigData-btn-account-balance-recharge': '财务结算,司机运费管理,司机运费支付,美的付账户余额-充值到一般户',
        'bigData-btn-account-balance-withdraw': '财务结算,司机运费管理,司机运费支付,美的付账户余额-去提现'
    },
    // 串货预警
    PerformanceCollusionWarning: {
        'bigData-btn-collusion-warning-handleTab': '订单管理-城配,串货预警,预警处理Tab',
        'bigData-btn-collusion-warning-detailTab': '订单管理-城配,串货预警,预警详情Tab',
        'bigData-btn-collusion-warning-detailTab-search': '订单管理-城配,串货预警,预警详情Tab,查询',
        'bigData-btn-collusion-warning-detailTab-viewBtn': '订单管理-城配,串货预警,预警详情Tab,查看',
        'bigData-btn-collusion-warning-detailTab-export': '订单管理-城配,串货预警,预警详情Tab,导出',
        'bigData-btn-collusion-warning-detailTab-exportDetail': '订单管理-城配,串货预警,预警详情Tab,导出明细',
        'bigData-btn-collusion-warning-handleTab-handleBtn': '订单管理-城配,串货预警,预警处理Tab,处理',
        'bigData-btn-collusion-warning-handleTab-export': '订单管理-城配,串货预警,预警处理Tab,导出',
        'bigData-btn-collusion-warning-handleTab-search': '订单管理-城配,串货预警,预警处理Tab,查询'
    },
    // 串货预警明细
    collusionWarningMap: {
        'bigData-btn-collusion-warningMap-submit': '订单管理-城配,串货预警明细,处理',
        'bigData-btn-collusion-warningMap-refresh': '订单管理-城配,串货预警明细,刷新',
        'bigData-btn-collusion-warningMap-tableShow': '订单管理-城配,串货预警明细,预警数据处理',
        'bigData-btn-collusion-warningMap-routeShow': '订单管理-城配,串货预警明细,高德首次规划线路'
    }
};
export default config;
